var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Shared value mapped to componentKey1: "+_vm._s(_vm.getSharedVariable("componentKey1")))]),_c('p',[_vm._v("Shared value mapped to componentKey2: "+_vm._s(_vm.getSharedVariable("componentKey2")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }